// extracted by css-extract-rspack-plugin
export default {"back-button":"BackButton-module__back-button--Q_O6C"};